import React, { Fragment, useEffect, useState, useContext } from 'react'
import { UrlServicesContext } from '../../components/UrlServicesContext'
import { Redirect } from 'react-router-dom'

import { Alert, Skeleton, Autocomplete } from '@material-ui/lab'
import { Grid, Box, TextField } from '@material-ui/core'
import axios from 'axios'

export default function LoadTestAccount(props) {
  const [results, setResults] = useState([])
  const [error, setError] = useState(false)
  const [isLoadedd, setIsLoadedd] = useState(false)
  const [returnLogin, setReturnLogin] = React.useState(false)

  let keyAuthorization = localStorage.getItem('Session')

  const { urlServices, keyAplication } = useContext(UrlServicesContext)

  useEffect(() => {
    axios
      .get(
        `${urlServices}tests/account/${localStorage.getItem('account_id')}`,
        {
          headers: {
            application: keyAplication,
            Authorization: 'Bearer ' + keyAuthorization,
          },
        }
      )
      .then((response) => {
        let result = response.data.data.filter(
          (filtered) => filtered.status === 1 || filtered.status === 2
          //&& filtered.managePasswords === true
        )
        setResults(result)
        setIsLoadedd(true)
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear()
            setReturnLogin(true)
          }, 200)
        } else {
          setError(true)
        }
      })
  }, [urlServices, keyAplication])

  if (returnLogin) {
    return <Redirect to="/" />
  }

  return (
    <Fragment>
      {error && (
        <Alert severity="error">
          Error en la consulta de <b>PRUEBAS DE LA CUENTA</b>
        </Alert>
      )}
      {!isLoadedd ? (
        <Fragment>
          <Grid item xs={12} sm={12}>
            <center>
              <Box sx={{ width: '100%' }}>
                <Skeleton width="100%" height={35} />
              </Box>
            </center>
          </Grid>
        </Fragment>
      ) : (
        <Autocomplete
          id="combo-box-demo"
          options={results}
          value={props.value}
          onChange={(event, newValue) => {
            props.refresh(newValue)
          }}
          getOptionLabel={(option) => option.name || ''}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Prueba"
              variant="standard"
              error={props.error}
              required
            />
          )}
        />
      )}
    </Fragment>
  )
}
